import React from "react";
import { useMutation, useQuery } from "@apollo/client";
import { useHistory } from "react-router";
import {
  Typography,
  ListItem,
  ListItemText,
  IconButton,
  Box,
  Tooltip,
} from "@material-ui/core";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import { get, isEmpty } from "lodash";
import { updateNotificationMutation } from "../../../graphQL/queries/notifications";
import { useStyles } from "../styles";
import reactStringReplace from "react-string-replace";
import {
  getCheckinDetails,
  getObjectiveDetails,
} from "../../../graphQL/queries/listCheckins";
import {
  CHECKIN,
  OVERVIEW,
  REPORTS,
  SUCCESS_STORIES,
  TARGET,
  TARGET_LIST,
  PROFILE,
  PERFORMANCE_REVIEW,
} from "../../../constants/routeConstants";
import { getUserId } from "../../../utils";
import { useRecoilState, useSetRecoilState } from "recoil";
import TargetImg from "../../../assets/images/targetDefault.svg";
import TargetClosedImg from "../../../assets/images/targetclosedDefault.svg";
import blueLine from "../../../assets/images/Blue-line.svg";
import TargetUserImg from "../../../assets/images/targetUser.svg";
import UserNotifImg from "../../../assets/images/user-notif.svg";
import CheckinDueImg from "../../../assets/images/checkinDue.svg";
import TargetAssignedDotImg from "../../../assets/images/targetAssigned.svg";
import TargetPausedImg from "../../../assets/images/targetPaused.svg";
import checkinResponsesDotImg from "../../../assets/images/checkinResponses.svg";
import TargetReview from "../../../assets/images/targetReview.svg";
import checkinAddedImg from "../../../assets/images/checkinAdded.svg";
import checkinDefaultImg from "../../../assets/images/check-inDefault.svg";
import PlannedTargetDotImg from "../../../assets/images/targetPlanned.svg";
import ObjectiveNeedHelpDotImg from "../../../assets/images/objectiveNeedHelpDot.svg";
import ObjectiveInProgressDotImg from "../../../assets/images/objectiveInProgressDot.svg";
import UserDeativatedDotImg from "../../../assets/images/gray-minus.svg";
import DefaultUserImg from "../../../assets/images/user-line.svg";
import BadgeImg from "../../../assets/images/badge.svg";
import GreenRight from "../../../assets/images/greenRight.svg";
import PurpleRight from "../../../assets/images/purpleRight.svg";
import TargetOverdue from "../../../assets/images/targetOverdue.svg";
import TargetEdited from "../../../assets/images/targetEdit.svg";
import ObjectiveImg from "../../../assets/images/objectiveCompleted.svg";
import SuccessStoryImg from "../../../assets/images/ss-default.svg";
import PerformanceReviewImg from "../../../assets/images/pr-default.svg";
import moment from "moment";
import { NOTIFICATION_LIST_DATE_TIME } from "../../../constants";
import {
  chickinNotificationId,
  objectiveNotificationId,
  targetListingState,
} from "Recoil/Targets/atom";
import deleted from "../../../assets/images/deleted.svg";
import restore from "../../../assets/images/restore.svg";
import archived from "../../../assets/images/archived.svg";
import Resume from "../../../assets/images/resume.svg";
import { updateOrangeDotStatus } from "GraphQL/mutation/targetReview";
import { dashboardTargetListingState } from "src/recoil/DashboardReports/atom";
const NotificationListItem = ({
  handleClose,
  getUserData,
  notification,
  isReadNotification,
}) => {
  let defaultImage = null;
  let isUserImage = null;
  let dotImage = null;
  let setNotificationCheckinId = useSetRecoilState(chickinNotificationId);
  let setNotificationObjectiveId = useSetRecoilState(objectiveNotificationId);
  const [targetList, setTargetList] = useRecoilState(targetListingState);
  const [dashboardTargetListing, setDashboardTargetListing] = useRecoilState(
    dashboardTargetListingState
  );
  const [updateOrangeDotRatingStatus] = useMutation(updateOrangeDotStatus);
  switch (notification.notificationType) {
    case "NewBadge":
      defaultImage = get(notification, "user.profileImage.fileName", false)
        ? `${process.env.REACT_APP_CLOUD_FRONT_URL}/${get(
            notification,
            "user.profileImage.fileName",
            ""
          )}`
        : DefaultUserImg;
      dotImage = BadgeImg;
      isUserImage = true;
      break;
    case "UserDeactivationToCreators":
      defaultImage = get(notification, "message.documentName", false)
        ? `${process.env.REACT_APP_CLOUD_FRONT_URL}/${get(
            notification,
            "message.documentName",
            ""
          )}`
        : UserNotifImg;
      dotImage = UserDeativatedDotImg;
      isUserImage = get(notification, "message.documentName", false);
      break;
    case "UserDeactivation":
      defaultImage = UserNotifImg;
      dotImage = UserDeativatedDotImg;
      break;
    case "MakingProgressForObjective":
      defaultImage = ObjectiveImg;
      dotImage = ObjectiveInProgressDotImg;
      break;
    case "NewCheckinAssigned":
      defaultImage = checkinDefaultImg;
      dotImage = TargetAssignedDotImg;
      break;
    case "ObjectiveCompletedByAllAssignedCoachees":
      defaultImage = ObjectiveImg;
      dotImage = GreenRight;
      break;
    case "NeedsHelpForObjective":
      defaultImage = ObjectiveImg;
      dotImage = ObjectiveNeedHelpDotImg;
      break;
    case "TargetActivated":
      defaultImage =
        get(notification, "message.title", false) === "New User Added To Target"
          ? TargetUserImg
          : TargetImg;
      dotImage =
        get(notification, "message.title", false) === "New User Added To Target"
          ? checkinAddedImg
          : TargetAssignedDotImg;
      break;
    case "OverdueTarget":
      defaultImage = TargetImg;
      dotImage = TargetOverdue;
      break;
    case "TargetCompleted":
      defaultImage = TargetImg;
      dotImage = GreenRight;
      break;
    case "TargetRestored":
      defaultImage = TargetImg;
      dotImage = restore;
      break;
    case "TargetUnpaused":
      defaultImage = TargetImg;
      dotImage = Resume;
      break;
    case "TargetEdited":
      defaultImage = TargetImg;
      dotImage = TargetEdited;
      break;
    case "TargetPaused":
      defaultImage = TargetImg;
      dotImage = TargetPausedImg;
      break;
    case "PlannedTarget":
      defaultImage = TargetImg;
      dotImage = PlannedTargetDotImg;
      break;
    case "TargetArchived":
      defaultImage = TargetImg;
      dotImage = archived;
      break;
    case "OverdueCheckin":
      defaultImage = checkinDefaultImg;
      dotImage = TargetOverdue;
      break;
    case "NotifyBeforeCheckinOverdue":
      defaultImage = checkinDefaultImg;
      dotImage = CheckinDueImg;
      break;
    case "CheckinCompleted":
    case "RateeCheckinCompleted":
      defaultImage = checkinDefaultImg;
      dotImage = GreenRight;
      break;
    case "CheckinEdited":
      defaultImage = checkinDefaultImg;
      dotImage = TargetEdited;
      break;
    case "NewCheckinCreated":
      defaultImage = checkinDefaultImg;
      dotImage = checkinAddedImg;
      break;
    case "PlannedCheckin":
      defaultImage = checkinDefaultImg;
      dotImage = PlannedTargetDotImg;
      break;
    case "TargetExtended":
      defaultImage = TargetImg;
      dotImage = TargetEdited;
      break;
    case "AdditionalPermissionAddedRemoved":
      defaultImage = get(notification, "user.profileImage.fileName", false)
        ? `${process.env.REACT_APP_CLOUD_FRONT_URL}/${get(
            notification,
            "user.profileImage.fileName",
            ""
          )}`
        : DefaultUserImg;
      dotImage = checkinAddedImg;
      isUserImage = true;
      break;
    case "changeInPermissions":
      defaultImage = get(notification, "user.profileImage.fileName", false)
        ? `${process.env.REACT_APP_CLOUD_FRONT_URL}/${get(
            notification,
            "user.profileImage.fileName",
            ""
          )}`
        : DefaultUserImg;
      dotImage = TargetEdited;
      break;
    case "ObjectiveAdded":
      defaultImage = ObjectiveImg;
      dotImage = TargetAssignedDotImg;
      break;
    case "targetReviewForRoleDeptChange":
      defaultImage = TargetImg;
      dotImage = TargetReview;
      break;
    case "CheckinResponseReceived":
      defaultImage = checkinDefaultImg;
      dotImage = checkinResponsesDotImg;
      break;
    case "TargetSubmitted":
      defaultImage = TargetImg;
      dotImage = GreenRight;
      break;
    case "TargetReviewForRoleDeptChange":
      defaultImage = TargetImg;
      dotImage = checkinResponsesDotImg;
      break;
    case "TargetAutoassignment":
      defaultImage = TargetImg;
      dotImage = checkinResponsesDotImg;
      break;
    case "SuccessStoryAdded":
      defaultImage = SuccessStoryImg;
      dotImage = checkinAddedImg;
      break;
    case "DiscussionPointsAddedByManager":
      defaultImage = SuccessStoryImg;
      dotImage = PurpleRight;
      break;
    case "SuccessStoryAcknowledged":
      defaultImage = SuccessStoryImg;
      dotImage = GreenRight;
      break;
    case "PerformanceReviewAdded":
      defaultImage = PerformanceReviewImg;
      dotImage = checkinAddedImg;
      break;
    case "DiscussionPointsAddedByManagerForPR":
      defaultImage = PerformanceReviewImg;
      dotImage = blueLine;
      break;
    case "PerformanceReviewAcknowledged":
      defaultImage = PerformanceReviewImg;
      dotImage = blueLine;
      break;
    case "NewUserAdded":
    case "NewCoachAdded":
      defaultImage = TargetImg;
      dotImage = TargetAssignedDotImg;
      break;
    case "NewUserAddedToCA":
    case "CoachToLR":
      defaultImage = TargetImg;
      dotImage = TargetAssignedDotImg;
      break;
    case "ReviewPendingTarget":
    case "CompleteTargetReview":
    case "ToSupportCoachReviewTarget":
      defaultImage = TargetClosedImg;
      dotImage = GreenRight;
      // dotImage = greenArrow;
      break;
    case "ToMemberForClosedTarget":
      defaultImage = TargetClosedImg;
      dotImage = GreenRight;
      break;
    case "AddedTakeaways":
      defaultImage = TargetClosedImg;
      dotImage = blueLine;
      break;
    case "PerformanceReviewDeleted":
      defaultImage = PerformanceReviewImg;
      dotImage = deleted;
      break;
    case "PerformanceReviewRestored":
      defaultImage = PerformanceReviewImg;
      dotImage = restore;
      break;
    case "PerformanceReviewArchived":
      defaultImage = PerformanceReviewImg;
      dotImage = archived;
      break;
    case "CheckinDeleted":
      defaultImage = checkinDefaultImg;
      dotImage = deleted;
      break;
    case "TargetDeleted":
      defaultImage = checkinDefaultImg;
      dotImage = deleted;
      break;
    case "OverdueTargetForCoach":
      defaultImage = TargetImg;
      dotImage = TargetOverdue;
      break;
    case "TargetTaggedUser":
    case "TargetLovedLiked":
    case "TargetMsgAdded":
      defaultImage = TargetImg;
      dotImage = blueLine;
      break;

    default:
      break;
  }
  const updateOrangeDotHighlightStatus = (objectId) => {
    const target = !isEmpty(targetList)
      ? targetList.filter((i) => i.id === objectId)
      : dashboardTargetListing.filter((i) => i.id === objectId);
    try {
      if (target[0]?.isNew) {
        updateOrangeDotRatingStatus({
          variables: {
            input: {
              targetid: target[0]?.id,
              userTargetId: getUserId(),
            },
          },
        })
          .then((res) => {
            let currentIndex = targetList?.findIndex(
              (res) => res?.id === objectId
            );

            setTargetList((list) => {
              const targetListData = [...list];
              targetListData[currentIndex] = {
                ...list[currentIndex],
                isNew: false,
              };
              return targetListData;
            });
          })
          .catch((error) => {
            console.log(error);
          });
      }

      // Update parent state based on API response
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  const fileName = get(notification, "message.target.logo.fileName", false);
  const targetImage =
    defaultImage ||
    (fileName
      ? `${process.env.REACT_APP_CLOUD_FRONT_URL}/${fileName}`
      : TargetImg);
  const classes = useStyles();
  const history = useHistory();
  const userId = getUserId();
  const { fetchMore: fetchCheckinTarget } = useQuery(getCheckinDetails);
  const { fetchMore: fetchObjectiveTarget } = useQuery(getObjectiveDetails);
  const [MyMutation] = useMutation(updateNotificationMutation);

  // const setReportDefaultDropdown = useSetRecoilState(
  //   reportDefaultDropdownState
  // );
  // const setReportType = useSetRecoilState(reportTypeState);

  const changeNotification = (variables, updateType) => {
    MyMutation({ variables })
      .then(() => {
        if (updateType === "isRead") {
          isReadNotification();
        } else if (updateType === "delete") {
          getUserData();
        }
      })
      .catch((error) => console.log(error));
  };

  const updateNotification = (notificationItem) => {
    if (!notificationItem.Isread) {
      const variables = {
        input: {
          userId,
          id: notificationItem.id,
          Isread: true,
        },
      };
      changeNotification(variables, "isRead");
    }
    openRespectiveTargetPage(notificationItem);
    handleClose();
  };

  const deleteNotification = (notificationItem) => {
    const variables = {
      input: {
        userId,
        id: notificationItem.id,
        isDeleted: true,
      },
    };
    changeNotification(variables, "delete");
  };

  const getCheckinTargetId = async (notificationItem) => {
    if (notificationItem.message.objectId) {
      const { data } = await fetchCheckinTarget({
        variables: {
          id: notificationItem.message.objectId,
        },
      });
      const targetId = get(data, "getCheckIn.target.id", null);
      if (!!targetId) {
        history.push(
          `${TARGET}${OVERVIEW}/${targetId}${CHECKIN}/${notificationItem.message.objectId}`
        );

        history.push({
          pathname: `${TARGET}${OVERVIEW}/${targetId}${CHECKIN}/${notificationItem.message.objectId}`,
          state: {
            respondedUserId: notificationItem?.createdBy?.id
              ? notificationItem?.createdBy?.id
              : notificationItem?.createdByUserId,
          },
        });
      }
    }
  };

  const getObjectiveTargetId = async (notificationItem) => {
    if (notificationItem.message.objectId) {
      const { data } = await fetchObjectiveTarget({
        variables: {
          id: notificationItem.message.objectId,
        },
      });
      const targetId = get(data, "getObjectiveTarget.target.id", null);
      if (!!targetId) {
        history.push({
          pathname: `${TARGET}${OVERVIEW}/${targetId}`,
          state: { currentTab: "objective" },
        });
        updateOrangeDotHighlightStatus(targetId);
      }
    }
  };
  // const setSelectedSuccessStory = useSetRecoilState(selectedSuccessStoryState);

  // const actionHandler = (pathname, data) => {
  //   history.push({
  //     pathname: `${pathname}`,
  //     state: { ...data }
  //   });

  //   setReportType({ key: data.filter });
  //   setSelectedSuccessStory({ ...data });
  //   setReportDefaultDropdown({ ...data, fromDashboard: true });
  // };

  const openRespectiveTargetPage = (notificationItem) => {
    console.log("notificationItem:", notificationItem);
    const reportPath = notificationItem?.message?.isPerformanceReview
      ? PERFORMANCE_REVIEW
      : SUCCESS_STORIES;
    switch (notificationItem.notificationType) {
      case "UserActivation":
      case "UserDeactivation":
      case "UserReactivation":
      case "CompanyActivation":
        break;
      case "TargetApprovalRequest":
      case "TargetActivated":
      case "TargetApproved":
      case "TargetRejected":
      case "TargetIncompleted":
      case "TargetPaused":
      case "TargetUnpaused":
      case "NewCompanyTarget":
      case "TargetSentForReviewByCoachee":
      case "TargetAvailableForReview":
      case "TargetMsgAdded":
      case "TargetLovedLiked":
      case "TargetTaggedUser":
      case "TargetRestored":
      case "TargetEdited":
      case "TargetExtended":
        history.push({
          pathname: `${TARGET}${OVERVIEW}/${notificationItem.message.objectId}`,
          state: {
            openActiveLogPanel:
              notificationItem.notificationType === "TargetEdited" || notificationItem.notificationType === "TargetUnpaused" || notificationItem.notificationType === "TargetExtended"
                ? true
                : false,
          },
        });
        console.log("Object Id:", notificationItem.message.objectId);
        updateOrangeDotHighlightStatus(notificationItem.message.objectId);
        break;
      case "OverdueTarget":
      case "OverdueTargetForCoach":
      case "NewUserAddedToCA":
        {
          history.push({
            pathname: `${TARGET}${OVERVIEW}/${notificationItem.message.targetId}`,
            state: {
              currentTab: "people",
              actionButton:
                notificationItem?.notificationType === "OverdueTargetForCoach"
                  ? true
                  : false,
              notificationItem,
              userId:
                notificationItem?.notificationType === "NewUserAddedToCA"
                  ? notificationItem.message.objectId
                  : notificationItem.userId,
            },
          });
        }
        break;
      case "TargetCompletionApprovalRequest":
      case "TargetCompletionRequestApproved":
      case "TargetCompletionRequestRejected":
      case "UserTargetMarkedCompletedByCreator":
      case "UserTargetSelfCompletion":
      case "NewCheckinAssigned":
      case "OverdueCheckin":
      case "TargetCompleted":
      case "NotifyBeforeCheckinOverdue":
      case "TargetArchived":
      case "NewCheckinCreated":
      case "PlannedTarget":
      case "PlannedCheckin":
      case "NewCompanyCheckinAssigned":
      case "CheckinEdited":
      case "NewUserAdded":
      case "NewCoachAdded":
      case "CoachToLR":
      case "TargetSubmitted": {
        let state = {};
        if (notificationItem.notificationType.includes("Checkin")) {
          state.currentTab = "checkin";
          state.checkinId = notificationItem.message.objectId;
          setNotificationCheckinId(notificationItem.message.objectId);
        }
        history.push({
          pathname: `${TARGET}${OVERVIEW}/${notificationItem.message.targetId}`,
          state,
        });
        updateOrangeDotHighlightStatus(notificationItem.message.targetId);

        break;
      }
      case "RateeCheckinCompleted": {
        // let state = {};
        setNotificationCheckinId(notificationItem.message.objectId);
        history.push({
          pathname: `${TARGET}${OVERVIEW}/${notificationItem.message.targetId}`,
          state: {
            currentTab: "checkin",
            checkinId: notificationItem.message.objectId,
            notificationItem: notificationItem,
          },
        });

        break;
      }

      case "ObjectiveAdded": {
        //   let state = {};
        setNotificationObjectiveId(notificationItem.message.objectId);
        history.push({
          pathname: `${TARGET}${OVERVIEW}/${notificationItem.message.targetId}`,
          state: {
            currentTab: "objective",
            objectiveId: notificationItem.message.objectId,
          },
        });
        break;
      }
      case "ReviewPendingTarget":
      case "CompleteTargetReview":
      case "ToSupportCoachReviewTarget":
      case "ToMemberForClosedTarget":
      case "AddedTakeaways":
        history.push({
          pathname: `${TARGET}${OVERVIEW}/${notificationItem.message.targetId}`,
          state: {
            currentTab: "people",
            userId: notificationItem?.id,
            notificationType: notificationItem.notificationType,
            userTargetId: notificationItem?.message?.objectId,
          },
        });
        break;
      case "MakingProgressForObjective":
      case "NeedsHelpForObjective": {
        setNotificationObjectiveId(notificationItem.message.objectId);
        getObjectiveTargetId(notificationItem);
        break;
      }
      // case "NewCompanyCheckinAssigned":
      // case "CheckinEdited":
      //   history.push(
      //     `${TARGET}${OVERVIEW}/${notificationItem.message.targetId}`
      //   );
      //   break;
      case "CheckinResponseReceived":
      case "CheckinCompleted":
        getCheckinTargetId(notificationItem);
        break;
      case "ObjectiveCompletedByAllAssignedCoachees":
        getObjectiveTargetId(notificationItem);
        break;
      case "NewBadge":
        history.push(`${PROFILE}/${notificationItem.message.objectId}/#badge`);
        break;
      case "AdditionalPermissionAddedRemoved":
      case "ChangeInPermissions":
        break;
      case "SuccessStoryAdded":
        history.push(
          `${REPORTS}${SUCCESS_STORIES}/${notificationItem.message.objectId}`
        );
        break;
      case "DiscussionPointsAddedByManager":
      case "PerformanceReviewAdded":
      case "DiscussionPointsAddedByManagerForPR":
        history.push({
          pathname: `${REPORTS}${reportPath}/${notificationItem.message.objectId}`,
          state: { discussionPoint: "discussionPoint" },
        });
        break;
      case "PerformanceReviewAcknowledged":
      case "SuccessStoryAcknowledged":
        history.push({
          pathname: `${REPORTS}${reportPath}/${notificationItem.message.objectId}`,
          state: { Acknowledged: "Acknowledged" },
        });
        break;
      case "PerformanceReviewClosed":
      case "PerformanceReviewUpdated":
        history.push(
          `${REPORTS}${reportPath}/${notificationItem.message.objectId}`
        );
        break;
      case "PerformanceReviewDeleted":
      case "PerformanceReviewRestored":
        history.push(`${REPORTS}${reportPath}`);
        break;

      case "PerformanceReviewArchived":
        // {
        history.push({
          pathname: `${REPORTS}${reportPath}`,
          state: {
            currentTab: "archived",
            gridName: notificationItem?.message?.isPerformanceReview
              ? "PerformanceReviewReportListing"
              : "SuccessStoryReportListing",
          },
        });
        break;
      // }
      // {
      //   let filter = "";
      //   if (notificationItem.message.successStoryType === "SingleCoachee") {
      //     if (notificationItem.message.successStoryCreator === userId) {
      //       filter = "TeamSuccessStories";
      //     } else {
      //       filter = "MySuccessStories";
      //     }
      //   } else {
      //     if (notificationItem.message.successStoryCreator === userId) {
      //       filter = "MySuccessStories";
      //     } else {
      //       filter = "TeamSuccessStories";
      //     }
      //   }
      //   actionHandler(`${REPORTS}${SUCCESS_STORIES}`, {
      //     id: notificationItem.message.objectId,
      //     title: notificationItem.message.successStoryTitle,
      //     type: notificationItem.message.successStoryType,
      //     filter
      //   });
      // }
      // break;
      case "TargetReviewForRoleDeptChange":
        const location = {
          pathname: `${TARGET}${TARGET_LIST}`,
          state: { redirectTo: "Teams" },
        };
        history.push(location);
        break;
      default:
        break;
    }
  };

  const targetDescription = () => {
    const condition = [
      "TargetApprovalRequest",
      "TargetActivated",
      "TargetApproved",
      "TargetRejected",
      "TargetCompleted",
      "TargetIncompleted",
      "TargetPaused",
      "TargetUnpaused",
      "NewCompanyTarget",
      "TargetEdited",
      "TargetSentForReviewByCoachee",
      "TargetAvailableForReview",
      "OverdueTarget",
      "UserTargetSelfCompletion",
      "NeedsHelpForObjective",
      "MakingProgressForObjective",
      "ObjectiveCompletedByAllAssignedCoachees",
      "NewCheckinAssigned",
      "CheckinEdited",
      "CheckinCompleted",
      "CheckinResponseReceived",
      "OverdueCheckin",
      "NewCompanyCheckinAssigned",
      "NotifyBeforeCheckinPublish",
      "NotifyBeforeCompanyCheckinPublish",
      "TargetCompletionApprovalRequest",
      "TargetCompletionRequestApproved",
      "TargetCompletionRequestRejected",
      "UserTargetMarkedCompletedByCreator",
      "UserTargetSelfCompletion",
      "TargetArchived",
      "TargetArchiveRejected",
      "TargetArchiveRequest",
      "NotifyBeforeCheckinOverdue",
      "NewCheckinCreated",
      "PlannedTarget",
      "PlannedCheckin",
      "TargetAutoassignment",
      "TargetSubmitted",
    ].includes(get(notification, "notificationType", ""));
    if (condition) {
      return reactStringReplace(
        get(notification, "message.description", ""),
        "#type# ",
        (match, i) => ""
      );
    } else {
      return get(notification, "message.description", "");
    }
  };

  return (
    <ListItem className={notification.Isread ? classes.readMessage : ""}>
      <ListItemText>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="flex-start"
          className={classes.notifyContent}
        >
          <Box
            width="90%"
            data-testid="box"
            onClick={() => updateNotification(notification)}
            display="flex"
          >
            <span
              className={
                !isUserImage ? classes.targetBackground : classes.noBackground
              }
            >
              <img
                src={targetImage}
                alt="cover image"
                className={!isUserImage ? classes.targetImg : classes.userImg}
              />
              <span className={classes.smallIcon}>
                <img width="20px" src={dotImage} />
              </span>
            </span>
            <Box>
              {!notification.Isread ? (
                <Typography variant="subtitle2" className="font-12 mb5">
                  <span className={classes.newTxt}>
                    <span
                      className="dot-indicator"
                      style={{
                        background: "#F3994E",
                      }}
                    ></span>
                    New
                  </span>
                </Typography>
              ) : (
                ""
              )}
              <Typography variant="subtitle2" className="font-13">
                {get(notification, "message.title", "")}
              </Typography>
              <Tooltip title={targetDescription()}>
                <Typography
                  variant="body2"
                  className="nofi-gray font-13 multi-wrap-3"
                >
                  {targetDescription()}
                </Typography>
              </Tooltip>
              <Typography variant="body2" className="nofi-gray font-13 mt5">
                {moment(
                  get(notification, "createdAt", "") || Date.now()
                ).format(NOTIFICATION_LIST_DATE_TIME)}
              </Typography>
            </Box>
          </Box>
          <Tooltip title="Remove">
            <IconButton
              aria-label="remove"
              onClick={() => deleteNotification(notification)}
              color="primary"
              size="small"
              className={classes.closeIcon}
              alignItems="center"
            >
              <CloseOutlinedIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>
      </ListItemText>
    </ListItem>
    // <NotificationSkeleton />
  );
};

export default NotificationListItem;
